import type {ParameterResponseBody} from '@dms/api/core';

import {COMPOSE_MESSAGE_MAX_PLACEHOLDERS} from '@prompt-bridge/shared/validations';

import type {Nullish} from 'shared/web';

import type {AiComposerPlaceholder} from './AiComposerDraft';

/**
 * The variable catalogue a compose request may carry: the canonical `{{ code }}` literal the
 * template editor emits for a new chip, capped deterministically at the contract's limit.
 */
export const toAiComposerPlaceholders = (
  parameters: Pick<ParameterResponseBody, 'code' | 'label'>[] | Nullish
): AiComposerPlaceholder[] =>
  (parameters ?? []).slice(0, COMPOSE_MESSAGE_MAX_PLACEHOLDERS).map((parameter) => ({
    literal: `{{ ${parameter.code} }}`,
    label: parameter.label,
  }));
